import React from 'react';
import {useTranslation} from 'react-i18next';
import {ICollectionModel} from '../../model/appModel';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';
import DeleteModal from '../modals/DeleteModal';
import {IMediaDetails} from '../../model/mediaDetails';
import {removeMediaFromCollection} from '../../context/collectionMediaProvider';
import styled from 'styled-components';
import decode from 'entity-decode';
import {clearBatchSelection} from '../../context/batchSelectionProvider';

const MediaList = styled.ul`
   list-style-type: none;
   overflow-x: auto; 
   white-space: nowrap;  
`;

const ItemDescriptionTitle = styled.span`
   margin-left: .5rem;
   flex: 0 1 auto;
`;
const ItemDescription = styled.li`
   display: flex;
   align-items: center;
`;

const IconContainer = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-right: 5px;
`;

export const CollectionMediaRemove: React.FC<ICollectionMediaRemoveProps> = ({onClose, collection, media}) => {
   const {t} = useTranslation();

   const mediaToRemove = {
      media: media,
      collection: collection
   };

   const mediaWarningMessage = (
      <>
         <p>
            {t('removeMedia.batch', {amount: media.length})}
         </p>
         <MediaList>
            {media.map((item, index) => (
               <ItemDescription key={index}>
                  <IconContainer>
                     {item.IsVideo ? <Glyphs.Video16x16 /> : <Glyphs.Image16x16 />}
                  </IconContainer>
                  <ItemDescriptionTitle>
                     {decode(item.Title)}
                  </ItemDescriptionTitle>
               </ItemDescription>
            ))}
         </MediaList>
      </>
   );

   const onDelete = () => {
      removeMediaFromCollection(media);
      clearBatchSelection();
   };

   return (
      <DeleteModal
         onClose={onClose}
         onDelete={onDelete}
         collectionMediaToDelete={mediaToRemove}
         title={t('removeMedia.title', {type: media.length > 1 ? t('removeMedia.mediaType') : media[0]?.IsVideo ? t('removeMedia.videoType') : t('removeMedia.imageType')})}
         warning={media.length > 1 ? mediaWarningMessage : t('removeMedia.warning', {media: decode(media[0]?.Title)})}
         deleteButtonText={t('general.remove')}
      />
   );
};

export interface ICollectionMediaRemoveProps {
   onClose(): void;
   collection: ICollectionModel;
   media: IMediaDetails[];
}

export default CollectionMediaRemove;
